<template>
  <div>
    <div class="inner-graph-container">
      <apexchart ref="chart" type="line" height="140" :options="chart.options" :series="chart.series"></apexchart>
    </div>
  </div>
</template>
<script>
  import Widget from '@/components/Widget/Widget';
  import axios from "axios";
  import { mapState } from "vuex";
  import gql from "graphql-tag";

  export default {
  name: 'Loader',
  components: { Widget },
  props: {
    data: {type: Array, default: function(){return []}},
    rails: {type: Array, default: function(){return []}},
    inverse: {type: Boolean, default: false},
    title: {type: String, default: 'Value'},
    units: {type: String, default: ''},
    pad: {type: Number, default: 5},
  },
  data(){
    return {
      categories:[],
      chart:{
        series: [],

        options: {

            colors: [({ value, seriesIndex, w }) => {
              let c = {
                '1': '#D9534F',
                '2': '#FF9821',
                '3': '#3ABF94',
              };
              if (this.rails.length){
                if (this.inverse){
                  if(value <= this.rails[0]) {
                    return '#3ABF94'
                  } else if (this.rails.length >=2 && value <= this.rails[1]) {
                    return '#FF9821'
                  } else {
                    return '#D9534F'
                  }
                }
                else {
                  if (value <= this.rails[0]) {
                    return '#D9534F'
                  } else if (this.rails.length >= 2 && value <= this.rails[1]) {
                    return '#FF9821'
                  } else {
                    return '#3ABF94'
                  }
                }
              }
              return '#164666';  // default
            }],

          plotOptions:{
            bar:{
              columnWidth: '100%',
            },
          },
          // markers:{
          //   size: 6,
          // },
          annotations:{
            xaxis:[ ]
          },
         chart: {
            type: 'bar',
            height: 20,
           width:100,
           sparkline:{
              enabled: true
           },
            toolbar: {
              show: false
            },
           zoom:{
              enabled:false,
           },
            events:{
              click:(event, chartContext, config)=>{
                if (config.dataPointIndex >= 0) {
                  this.chart.options.annotations.xaxis[0].x = this.categories[config.dataPointIndex];
                  this.chart.options.annotations.xaxis[0].label.text = this.$moment(new Date(this.data[config.dataPointIndex].started_at).getTime()).format('hh:mma');
                  this.$refs.chart.updateOptions({...this.chart.options})
                  this.$router.push({query: {c: this.data[config.dataPointIndex].crawl}});
                }
              },
              dataPointMouseEnter: function(event) {
            //    event.path[0].style.cursor = "pointer";
              }
            },
          },
          stroke: {
            width: 1,
            // curve: 'straight'
          },
          tooltip:{
            enabled: true,
            intersect: true,
            shared: false,
            x:{
              show: true,
            },
            marker:{
              show: false
            },
            y:{
              title:{
                formatter: (v)=> {return false}
              },
              formatter: (v)=> {
                if (this.units === 'ms'){
                  return v.toFixed(0) + 'ms';
                }
                if (this.units === 'size'){
                  return this.$options.filters.bytes(v);
                }
                return v
              }
            },

            // fixed:{
            //   enabled: false,
            // }
          },

          xaxis: {
            type: 'category',
            categories: [
            ],
            labels: {
              rotate:0,
            },
              // formatter: (value)=> {
              //   // return  [this.$moment(value).format('MMM D hh:mm')];
              //   return  [this.$moment(value).format('MMM D'), this.$moment(value).format('hh:mm')];
              // }
            // }
          },

          legend: {
            position: 'bottom',
          },
          dataLabels: {
            enabled: false
          },
        },
      },
      completed: false,
      showModal: this.show,
      error: '',
      subscription: {},
      submitting: false,
    }
  },
  methods: {

  },
  computed: {
    ...mapState({  user: "user" }),
  },
  mounted() {
    this.submitting = false;
    let series = [];

    series.push({name: 'value', data:[]});


    series  =[{name: this.title, data:[]}]
    this.categories = [];
    let xannotations = [];
    for (let entry of this.data){
      for (let serie of series){
        serie.data.push(entry.data || 0)
      }
      this.categories.push([this.$moment(entry.timestamp).format('MMM D,  h:mm a')]);
    }

    let start_time = this.$moment(this.data[0].timestamp).subtract(0, 'days');
    if (this.pad){
      let padSize = this.pad - this.data.length;
      for (let i=0; i<padSize; i++){
        start_time = start_time.subtract(1, 'days');
        this.categories.unshift([start_time.format('MMM D')]);
        // this.categoryParams.unshift(null);
        for (let serie of series){
          serie.data.unshift(0);
        }
      }

    }

    this.chart.options.xaxis.categories = this.categories;

    this.chart.options.annotations.xaxis = xannotations;

    this.$refs.chart.updateOptions({...this.chart.options})
   this.$refs.chart.updateSeries(series)
  },
}
</script>
